import type { FareTypeStoryblok, ServiceSummaryStoryblok } from '@/storyblok/component-types-sb'

export interface IFareTypeGroupKey {
  key: string
  title: string
}

export const FARE_TABLE_CLUB_LEVEL_NONE = 'NONE' as const
export const FARE_TABLE_CLUB_LEVEL_CLUB = 'CLUB' as const
export const FARE_TABLE_CLUB_LEVEL_EXECUTIVE = 'EXECUTIVE' as const
export const FARE_TABLE_CLUB_LEVEL_VIP = 'VIP' as const

export const FARE_TABLE_CLUB_LEVEL = {
  none: FARE_TABLE_CLUB_LEVEL_NONE,
  club: FARE_TABLE_CLUB_LEVEL_CLUB,
  executive: FARE_TABLE_CLUB_LEVEL_EXECUTIVE,
  vip: FARE_TABLE_CLUB_LEVEL_VIP
} as const

export type TFareTableClubLevel =
  | typeof FARE_TABLE_CLUB_LEVEL_NONE
  | typeof FARE_TABLE_CLUB_LEVEL_CLUB
  | typeof FARE_TABLE_CLUB_LEVEL_EXECUTIVE
  | typeof FARE_TABLE_CLUB_LEVEL_VIP

export const FARE_TABLE_TRAVEL_WITH_INFANT = 'INFANT' as const
export const FARE_TABLE_TRAVEL_WITH_CHILD = 'CHILD' as const

export const FARE_TABLE_TRAVEL_WITH = {
  infant: FARE_TABLE_TRAVEL_WITH_INFANT,
  child: FARE_TABLE_TRAVEL_WITH_CHILD
} as const

export type TFareTableTravelWith = Extract<
  NonNullable<ServiceSummaryStoryblok['service']>,
  typeof FARE_TABLE_TRAVEL_WITH_INFANT | typeof FARE_TABLE_TRAVEL_WITH_CHILD
>

export interface IFareTableFiltersModel {
  fareKeys: string[]
  clubLevel: TFareTableClubLevel
  travelWith: TFareTableTravelWith[]
}

export interface IFareOption {
  label: string
  value: string
}

export interface IFareOptionsByGroup {
  individual: IFareOption[]
  interline: IFareOption[]
  corporate: IFareOption[]
}

export type TFareTableFare = FareTypeStoryblok

export type TFareTableQueryValue = string | null | (string | null)[] | undefined
